import { supabase } from '../lib/supabase';
import { GoogleCalendarConnection, Reminder } from '../types';

type EntityType = 'deal' | 'marketing_lead';

export const googleCalendarService = {
  initiateOAuth: async (): Promise<{ authUrl: string } | { error: any }> => {
    try {
      const { data, error } = await supabase.functions.invoke('gcal-oauth-init', { body: {} });
      if (error) return { error };
      return { authUrl: data.authUrl };
    } catch (e: any) {
      return { error: e.message || 'Erreur inconnue' };
    }
  },

  completeOAuth: async (code: string, state?: string): Promise<{ success: boolean; connection?: any; error?: any }> => {
    try {
      const { data, error } = await supabase.functions.invoke('gcal-oauth-callback', { body: { code, state } });
      if (error) return { success: false, error };
      return data;
    } catch (e: any) {
      return { success: false, error: e.message || 'Erreur inconnue' };
    }
  },

  getConnection: async (): Promise<GoogleCalendarConnection | null> => {
    const { data, error } = await supabase
      .from('google_calendar_connections')
      .select('*')
      .eq('is_active', true)
      .maybeSingle();
    if (error || !data) return null;
    return {
      id: data.id,
      userId: data.user_id,
      agencyId: data.agency_id,
      googleEmail: data.google_email,
      calendarId: data.calendar_id,
      calendarSummary: data.calendar_summary,
      accessToken: data.access_token,
      refreshToken: data.refresh_token,
      tokenExpiresAt: data.token_expires_at,
      syncToken: data.sync_token,
      watchChannelId: data.watch_channel_id,
      watchResourceId: data.watch_resource_id,
      watchExpiresAt: data.watch_expires_at,
      isActive: data.is_active,
      lastSyncedAt: data.last_synced_at,
      createdAt: data.created_at,
      updatedAt: data.updated_at,
    };
  },

  disconnect: async (): Promise<{ error?: any }> => {
    const { error } = await supabase.from('google_calendar_connections').update({ is_active: false }).eq('is_active', true);
    return error ? { error } : {};
  },

  syncOutbound: async (entityType: EntityType, entityId: string, oldReminders: Reminder[], newReminders: Reminder[]) => {
    const { data, error } = await supabase.functions.invoke('gcal-sync-outbound', {
      body: { entityType, entityId, oldReminders, newReminders },
    });
    return { data, error };
  },

  syncPull: async () => {
    const { data, error } = await supabase.functions.invoke('gcal-sync-pull', { body: {} });
    return { data, error };
  },
};
